import { render, staticRenderFns } from "./MyAvatar.vue?vue&type=template&id=05bc8e62&scoped=true&"
import script from "./MyAvatar.vue?vue&type=script&lang=js&"
export * from "./MyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MyAvatar.vue?vue&type=style&index=0&id=05bc8e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc8e62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VAvatar,VBadge})
